import { render, staticRenderFns } from "./LegalConfigPanel.vue?vue&type=template&id=52445d54"
import script from "./LegalConfigPanel.vue?vue&type=script&lang=js"
export * from "./LegalConfigPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports